var _circle, _circle2, _circle3, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModalMeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 23,
    fill: "#2E26FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1635 33.382C43.0733 33.382 42.1914 33.7418 42.1914 34.1833V54.1847C42.1914 54.6263 43.0733 54.9861 44.1635 54.9861C45.2538 54.9861 46.1357 54.6263 46.1357 54.1847V34.1833C46.1357 33.7418 45.2538 33.382 44.1635 33.382Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6853 33.1693C36.611 33.0221 35.6971 33.251 35.633 33.6926L33.0035 53.5305C32.9393 53.9721 33.7731 54.4463 34.8473 54.5935C35.9216 54.7407 36.8355 54.5117 36.8996 54.0702L39.5292 34.2323C39.5933 33.7907 38.7595 33.3165 37.6853 33.1693Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6389 33.1693C49.5646 33.3165 48.7469 33.7907 48.795 34.2323L51.4245 54.0538C51.4886 54.4954 52.4026 54.7244 53.4768 54.5772C54.5511 54.43 55.3688 53.9557 55.3207 53.5141L52.6912 33.6926C52.6431 33.251 51.7131 33.0221 50.6389 33.1693Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModalMeo);
export default __webpack_public_path__ + "static/media/logoModalMeo.8b61d6ff79035b9dfb316c6558397c70.svg";
export { ForwardRef as ReactComponent };